module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.78dcec2a.ttf";